import instantsearch from 'instantsearch.js/es';
import { searchBox } from 'instantsearch.js/es/widgets';
import enableAlgolia from './enable-algolia';
import { searchClient } from './search-client';
import { searchPageResult } from './search-page.js';

/**
 * The different type of searches imported
 */
import postTypeSearch from './searches/post-type-search';
import productSearch from './searches/product-search';
import taxonomySearch from './searches/taxonomy-search';
import { analyticsWidget } from './analytics';
import { attachInsightsMiddleware, insightsMiddleware } from './insights';

const maksimerAlgoliaSearch = () => {
	// Return if something is missing to be able to do algolia search
	if ( ! enableAlgolia() ) {
		return;
	}

	const container = MWC_AIS.dom_selectors.input_selector;

	const containerDomElm = document.querySelector( container );
	const oldSearchForm = containerDomElm.querySelector( 'form' );

	let placeholder = '';

	if ( oldSearchForm ) {
		const oldSearchInput = oldSearchForm.querySelector( 'input' );

		if ( oldSearchInput ) {
			placeholder = oldSearchInput.getAttribute( 'placeholder' );
		}

		oldSearchForm.remove();
	}

	const resultsMain = document.querySelector( '.maksimer_algolia_search' );

	/**
	 * Initialize Algolia instantsearch
	 * TODO: What to do with indexName here?
	 * TODO: This actually makes the product index be hit twice
	 */

	window.dataLayer = window.dataLayer || [];

	let searchTimer,
		search,
		searchInitialized = false;

	const initializeSearch = ( index ) => {
		search = instantsearch( {
			indexName: index,
			searchClient,
			searchFunction: ( helper ) => {
				if ( helper.state.query.length > 0 ) {
					window.dataLayer.push( {
						event: 'maksimer_algolia_search',
						search_term: helper.state.query,
					} );

					resultsMain.style.display = 'block';
					helper.search();
				} else {
					resultsMain.style.display = 'none';
				}
			},
		} );

		search.on( 'error', ( { error } ) => {
			console.error( error );
		} );

		/**
		 * Initialize and append algolia search widget to the selected dom element
		 * woocommerce-product-search
		 */
		search.addWidgets( [
			searchBox( {
				container,
				placeholder,
				showMore: true,
				autofocus: false,
				showSubmit: false,
				searchAsYouType: MWC_AIS.search_as_you_type === 'yes',
				queryHook( query, refine ) {
					clearTimeout( searchTimer );
					searchTimer = setTimeout( () => refine( query ), 500 );
				},
			} ),
		] );

		analyticsWidget( search );
		attachInsightsMiddleware( search );
	};

	/**
	 * Add the different indexes to include in search
	 * Product needs special treatment and has it's own search function
	 */
	if ( Object.keys( MWC_AIS.post_types ).length ) {
		Object.keys( MWC_AIS.post_types ).forEach( ( key ) => {
			const postType = MWC_AIS.post_types[ key ];

			if ( ! searchInitialized ) {
				initializeSearch( postType.ais_index );

				searchInitialized = true;
			}

			const postTypeResultContainer = document.querySelector(
				`.ma-${ postType.type }-result-wrapper`
			);

			if ( ! postTypeResultContainer ) {
				console.warn(
					`Tried adding algolia search for ${ postType.type } but the div is missing`
				);
			} else if ( 'product' === postType.type ) {
				productSearch.searcher( search, postType );
			} else {
				postTypeSearch.searcher( search, postType );
			}
		} );
	}

	/**
	 * Add the different taxonomy indexes to include in search
	 */
	if ( Object.keys( MWC_AIS.taxonomies ).length ) {
		Object.keys( MWC_AIS.taxonomies ).forEach( ( key ) => {
			const taxonomy = MWC_AIS.taxonomies[ key ];

			const postTypeResultContainer = document.querySelector(
				`.ma-${ taxonomy.type }-result-wrapper`
			);

			if ( ! postTypeResultContainer ) {
				console.warn(
					`Tried adding algolia search for ${ taxonomy.type } but the div is missing`
				);
			} else {
				taxonomySearch.searcher( search, taxonomy );
			}
		} );
	}

	/**
	 * Fire off the search, without this nothing will happen and your life would be a sad life without algolia search
	 */
	search.start();
};

maksimerAlgoliaSearch();

searchPageResult();
